import {takeEvery} from 'redux-saga/effects'
import {
  ADD_EXAM,
  ASSIGN_EXAM_MARKS_TO_ALL,
  CREATE_GRADING_KEY,
  DELETE_GRADING_KEY,
  DELETE_MANY_EXAMS,
  DELETE_MANY_GRADING_KEY,
  DELETE_REPORT_CARD_RESULT,
  DELETE_SINGLE_EXAM,
  DELETE_STUDENT_REPORT_CARD,
  DOWNLOAD_REPORT_CARD_PDF,
  FETCH_STUDENT_ACADEMIC_COMMENTS,
  GENERATE_ACADEMIC_PERFORMANCE_REPORT,
  GET_ALL_GRADING_KEY,
  GET_EXAMS,
  GET_EXAM_GRACE_MARKS,
  GET_EXAM_GRADES,
  GET_EXAM_LABELS,
  GET_EXAM_REPORT,
  GET_EXAM_RESULTS,
  GET_EXAM_SETUP_STATUS,
  GET_EXAM_TYPE_WEIGHTAGES,
  GET_GRADING_KEY_TEMPLATE,
  GET_REPORT_CARD_RESULTS,
  GET_REPORT_CARD_RESULT_STUDENTS,
  GET_REPORT_CARD_SETTINGS,
  GET_SKILL_REPORTS,
  GET_SKILL_REPORT_SHEET,
  GET_STUDENT_EXAM_REPORT_CARDS,
  GET_STUDENT_PREVIOUS_SESSION_EXAM_REPORT_CARDS,
  GET_STUDENT_VARIABLE_VALUES,
  MISSING_GRADING_KEY,
  PUBLISH_MANY_EXAMS,
  PUBLISH_REPORT_CARDS,
  SAVE_ALL_STUDENT_VARIABLE_VALUES,
  SAVE_EXAM_GRACE_MARKS,
  SAVE_EXAM_TYPE_WEIGHTAGES,
  SAVE_GRADING_KEY_TEMPLATE,
  SAVE_REPORT_CARD_SETTINGS,
  SAVE_SKILL_REPORT_SHEET,
  SAVE_STUDENT_ACADEMIC_COMMENTS,
  SAVE_STUDENT_VARIABLE_VALUES,
  SEND_EXAM_NOTIFICATION,
  SEND_EXAM_SMS,
  SEND_REPORT_CARD_MAIL,
  SEND_REPORT_CARD_NOTIFICATION,
  UPDATE_EXAM,
  UPDATE_EXAM_RESULT,
  UPDATE_GRADING_KEY,
  UPDATE_REPORT_CARD_RESULT,
  VIEW_GRADING_KEY,
  VIEW_SELECTED_EXAM,
} from 'setup/redux/Actions/Exam/ActionTypes/ApiActionTypes'

import fetchData from '../../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_EXAMS, fetchData)
  yield takeEvery(VIEW_SELECTED_EXAM, fetchData)
  yield takeEvery(ADD_EXAM, fetchData)
  yield takeEvery(UPDATE_EXAM, fetchData)
  yield takeEvery(DELETE_SINGLE_EXAM, fetchData)
  yield takeEvery(DELETE_MANY_EXAMS, fetchData)
  yield takeEvery(PUBLISH_MANY_EXAMS, fetchData)
  yield takeEvery(SEND_EXAM_NOTIFICATION, fetchData)
  yield takeEvery(SEND_EXAM_SMS, fetchData)
  yield takeEvery(GET_EXAM_LABELS, fetchData)
  yield takeEvery(GET_EXAM_SETUP_STATUS, fetchData)
  yield takeEvery(GET_EXAM_GRADES, fetchData)
  yield takeEvery(GET_STUDENT_EXAM_REPORT_CARDS, fetchData)
  yield takeEvery(GET_STUDENT_PREVIOUS_SESSION_EXAM_REPORT_CARDS, fetchData)
  yield takeEvery(FETCH_STUDENT_ACADEMIC_COMMENTS, fetchData)
  yield takeEvery(SAVE_STUDENT_ACADEMIC_COMMENTS, fetchData)
  yield takeEvery(GET_ALL_GRADING_KEY, fetchData)
  yield takeEvery(CREATE_GRADING_KEY, fetchData)
  yield takeEvery(VIEW_GRADING_KEY, fetchData)
  yield takeEvery(GET_GRADING_KEY_TEMPLATE, fetchData)
  yield takeEvery(SAVE_GRADING_KEY_TEMPLATE, fetchData)
  yield takeEvery(DELETE_GRADING_KEY, fetchData)
  yield takeEvery(DELETE_MANY_GRADING_KEY, fetchData)
  yield takeEvery(UPDATE_GRADING_KEY, fetchData)
  yield takeEvery(MISSING_GRADING_KEY, fetchData)
  yield takeEvery(GENERATE_ACADEMIC_PERFORMANCE_REPORT, fetchData)
  yield takeEvery(DOWNLOAD_REPORT_CARD_PDF, fetchData)
  yield takeEvery(GET_EXAM_RESULTS, fetchData)
  yield takeEvery(GET_EXAM_REPORT, fetchData)
  yield takeEvery(UPDATE_EXAM_RESULT, fetchData)
  yield takeEvery(ASSIGN_EXAM_MARKS_TO_ALL, fetchData)
  yield takeEvery(GET_EXAM_GRACE_MARKS, fetchData)
  yield takeEvery(SAVE_EXAM_GRACE_MARKS, fetchData)
  yield takeEvery(GET_EXAM_TYPE_WEIGHTAGES, fetchData)
  yield takeEvery(SAVE_EXAM_TYPE_WEIGHTAGES, fetchData)
  yield takeEvery(GET_REPORT_CARD_RESULTS, fetchData)
  yield takeEvery(GET_REPORT_CARD_RESULT_STUDENTS, fetchData)
  yield takeEvery(PUBLISH_REPORT_CARDS, fetchData)
  yield takeEvery(SEND_REPORT_CARD_NOTIFICATION, fetchData)
  yield takeEvery(SEND_REPORT_CARD_MAIL, fetchData)
  yield takeEvery(UPDATE_REPORT_CARD_RESULT, fetchData)
  yield takeEvery(DELETE_REPORT_CARD_RESULT, fetchData)
  yield takeEvery(DELETE_STUDENT_REPORT_CARD, fetchData)
  yield takeEvery(GET_SKILL_REPORTS, fetchData)
  yield takeEvery(GET_SKILL_REPORT_SHEET, fetchData)
  yield takeEvery(SAVE_SKILL_REPORT_SHEET, fetchData)
  yield takeEvery(GET_STUDENT_VARIABLE_VALUES, fetchData)
  yield takeEvery(SAVE_ALL_STUDENT_VARIABLE_VALUES, fetchData)
  yield takeEvery(SAVE_STUDENT_VARIABLE_VALUES, fetchData)
  yield takeEvery(GET_REPORT_CARD_SETTINGS, fetchData)
  yield takeEvery(SAVE_REPORT_CARD_SETTINGS, fetchData)
}

export default dataSaga
